import { render, staticRenderFns } from "./henri-bonneau.vue?vue&type=template&id=67d5f6ce&scoped=true"
import script from "./henri-bonneau.vue?vue&type=script&lang=js"
export * from "./henri-bonneau.vue?vue&type=script&lang=js"
import style0 from "./henri-bonneau.vue?vue&type=style&index=0&id=67d5f6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5f6ce",
  null
  
)

export default component.exports